import { render, staticRenderFns } from "./CmgNonMemberRewards.vue?vue&type=template&id=a575dcac&scoped=true&lang=pug&"
import script from "./cmg-non-member-rewards.ts?vue&type=script&lang=ts&"
export * from "./cmg-non-member-rewards.ts?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "a575dcac",
  null
  
)

export default component.exports